import script from "./AutoAIAgentModal.vue?vue&type=script&setup=true&lang=ts"
export * from "./AutoAIAgentModal.vue?vue&type=script&setup=true&lang=ts"

import "./AutoAIAgentModal.vue?vue&type=style&index=0&id=1a1445f9&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1a1445f9"]])

export default __exports__